import SearchIcon from '@mui/icons-material/Search';
import WifiOffIcon from '@mui/icons-material/WifiOff';
/**
 * custom props for the empty table
 */
interface Props {
    /**
     * flag that tells if there's no resoult found
     */
    noResults: boolean;
    /**
     * flag that tells that endpoint couldn't fetch data
     */
    apiError: boolean;
}

/**
 * component that shows an empty message to handle an empty table 
 */
export const EmptyTableMessage = ({ apiError, noResults }: Props) => {

    /**
     * Renders a message for an empty table result
     * colspan={999} is just a big enough number to ensure all the columns are occupied when rendering the message
     */
    const renderComponent = () => {
        if (apiError) {
            return (
                <tr className="text-center" >
                    <td style={{ padding: '10 px', height: '300px' }} colSpan={999}>
                        <WifiOffIcon sx={{ fontSize: 100 }} />
                        <h4><strong>No pudimos obtener los datos del servidor</strong></h4>
                    </td>
                </tr>
            )
        } else if (noResults) {
            return (
                <tr className="text-center" >
                    <td style={{ padding: '10 px', height: '300px' }} colSpan={999}>
                        <h4><strong>No se encontraron resultados</strong></h4>
                        <SearchIcon sx={{ fontSize: 50 }} />
                    </td>
                </tr>
            )
        }
        return null;
    }

    return (
        renderComponent()
    )
}
